export default __webpack_public_path__ + "static/media/H4010.1.e7b3cd5d.mp3";